import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsInstapaperComponent } from './simple-icons-instapaper.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsInstapaperComponent ],
    exports:      [ SimpleIconsInstapaperComponent ],
    bootstrap:    []
})
export class SimpleIconsInstapaperModule {}
